import { useState, useCallback } from 'react';

import { TLanguageTag, userLanguage } from '../services/userLanguage';

const useUserLanguage = () => {
  const [language, setLanguageState] = useState<TLanguageTag>(userLanguage.getLanguage());

  const setLanguage = useCallback(
    (nextLanguage: TLanguageTag) => {
      setLanguageState(userLanguage.setLanguage(nextLanguage));
    },
    [setLanguageState],
  );

  return {
    language,
    setLanguage,
  };
};

export { useUserLanguage };
